import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import RootRouter from './RootRouter';
import ScrollToTop from './components/ScrollToTop';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        {/* Garantir scroll ao topo em páginas internas */}
        <ScrollToTop />
        <RootRouter />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Registro do Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          // console.log('SW registrado com sucesso: ', registration);
        })
        .catch((registrationError) => {
          // console.log('SW falhou ao registrar: ', registrationError);
        });
  });
}

// Medição de Web Vitals para performance
// reportWebVitals(console.log);